import { FC } from 'react'
import { LayoutHeader } from '@/components/domains/layouts'
import PolicyBeforePrivacy from '@/components/domains/policy/PolicyLocationBeforeService20230424'

const PagePolicyBeforeLocationPrivacy20230424: FC = () => {
  return (
    <>
      <LayoutHeader />
      <PolicyBeforePrivacy />
    </>
  )
}

export default PagePolicyBeforeLocationPrivacy20230424
